import {Component, Input, OnInit} from '@angular/core';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {RegistryService} from '../../services/registry.service';
import {CustomerService} from '../../../admin/services/customer.service';
import {SliderService} from '../../services/slider.service';
import {Slider} from '../../../admin/models/slider';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

    @Input('storeview') storeview = 'default';

    slider: Slider;
    lang = 'ar';
    env = environment;

    constructor(
        private registry: RegistryService,
        private sliderService: SliderService,
        private customerService: CustomerService
    ) {
    }

    customOptions: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        lazyLoad: true,
        navSpeed: 200,
        dots: true,
        nav: false,
        slideBy: 1,
        autoplay: false,
        navText: ["<div class='nav-btn prev-slide  p-slider-arrow-left'>" +
        "<i class='la la-chevron-circle-left'></i></div>",
            "<div class='nav-btn next-slide p-slider-arrow-right'><i class='la la-chevron-circle-right'></i></div>"],
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 1
            },
            740: {
                items: 1
            },
            940: {
                items: 1
            }
        }
    };

    ngOnInit(): void {

        this.loadSlider();
        this.lang = this.customerService.getCurrentLang();
    }

    getBannerImages(component_type, key) {
        return this.registry.mobileConfigs.getConfigKeyByComponent(component_type, key);

    }

    loadSlider() {


        this.sliderService.getSliderByViewstore(this.storeview).subscribe(slider => {

            this.slider = slider;
            this.customOptions.dots = this.slider.dots == '1' ? true : false;
            this.customOptions.autoplay = this.slider.autoplay == '1' ? true : false;
            this.customOptions.loop = this.slider.loop == '1' ? true : false;
            this.customOptions.nav = this.slider.show_prev == '1' ? true : false;
            this.customOptions.slideTransition = this.slider.transition_effect;
            this.customOptions.autoplayTimeout = parseInt(this.slider.autoplay_timeout);
        });


    }

}
